import type { SessionContext, StepType } from '@esign/contracts'
import type { StepperItem } from '@esign/ui'

/**
 * Dịch `SessionContext` sang 4 bước hiển thị trên Stepper Figma.
 *
 * Backend có 5 bước (`info`, `link_account`, `ekyc`, `review`, `sign`),
 * giao diện Figma gom `review` và `sign` vào bước hiển thị thứ 4 ("Xác nhận").
 */
export function stepperItems(context: SessionContext): StepperItem[] {
  const { flow, session } = context
  const signed = session.status === 'signed'
  const configured = new Set(flow.steps.map((step) => step.type))
  const groups: Array<{ key: string; label: string; types: StepType[] }> = [
    { key: 'info', label: 'Thông tin', types: ['info'] },
    { key: 'link_account', label: 'Liên kết tài khoản', types: ['link_account'] },
    { key: 'ekyc', label: 'Xác thực danh tính', types: ['ekyc'] },
    { key: 'confirmation', label: 'Xác nhận', types: ['review', 'sign'] },
  ]

  return groups
    .map((group) => ({ ...group, types: group.types.filter((type) => configured.has(type)) }))
    .filter((group) => group.types.length > 0)
    .map((group) => ({
      key: group.key,
      label: group.label,
      state: signed
        ? 'done'
        : group.types.includes(session.current_step)
          ? 'current'
          : group.types.every((type) => session.completed_steps.includes(type))
            ? 'done'
            : 'todo',
    }))
}
